<script setup>
import $ from "jquery";
import { onMounted, ref } from 'vue';
import { getEnergyChange } from "@/api/common"
import { ElRow, ElCol } from 'element-plus'
import { useRouter } from "vue-router";
const { currentRoute } = useRouter();
const router = currentRoute.value
let $ul;
let timeID;
let lis = ref([])
onMounted(() => {
    getEnergyChange(router.query.projectId).then(res => {
        if (res.success) {
            lis.value = res.data;
            if (res.data.length > 4) {
                $ul = $('#table-roll');
                roll()
            }
        }
    })
})
function roll() {
    clearInterval(timeID);
    timeID = setInterval(function () {
        clearInterval(timeID);
        $ul.animate({ top: "0px" }, 1000, function () {
            $ul.find("li:first").removeClass().addClass('roll_hide').appendTo($ul);

            for (var i = 0; i < 5; i++) {
                $ul.find("li").eq(i).removeClass().addClass('roll_' + i)
            }
            roll()
        })
    }, 10000);
}
</script>

<template>
    <div class="table-roll-box">
        <ul class="border-roll">
            <li>
                <div class="border-image"></div>
            </li>
            <li>
                <div class="border-image"></div>
            </li>
            <li>
                <div class="border-image"></div>
            </li>
            <li></li>
        </ul>
        <ul id="table-roll" class="table-roll">
            <li v-for="(item, index) in lis" :key="index" :class="index < 5 ? 'roll_' + index : 'roll_hide'">
                <el-row class="width100">
                    <el-col :span="10"><i class="iconfont icon-dianbiao fz-lg color-orange"></i><span
                            class="ml-10 colorWhite">{{ item.name }}</span></el-col>
                    <el-col :span="7"><span class="colorWhite fz-sm"><span class="mr-10 colorLG fz-lg">{{ item.value
                    }}</span>kW.h</span></el-col>
                    <el-col :span="7">
                        <i v-if="item.change === 0" class="iconfont icon-icdash colorY fz-md"></i>
                        <i v-if="item.change === 1" class="iconfont icon-shangsheng colorLG fz-md"></i>
                        <i v-if="item.change === -1" class="iconfont icon-xiajiang colorDR fz-md"></i>
                        <span class="colorWhite ml-10">{{ item.changeValue }}%</span>
                    </el-col>
                </el-row>
                <!-- <div class="col4">
                    <i class="iconfont icon-dianbiao fz-lg color-orange"></i>
                  
                    <b class="ml-10 colorWhite">{{ item.name }}</b>
                
                </div> -->
                <!-- <div class="col4">
                    <span class="colorWhite fz-sm"><span class="mr-10 colorLG fz-lg">{{ item.value }}</span>kW.h</span>
                </div> -->
                <!-- <div class="col2">
                    <i v-if="item.change === 0" class="iconfont icon-icdash colorY fz-md"></i>
                    <i v-if="item.change === 1" class="iconfont icon-shangsheng colorLG fz-md"></i>
                    <i v-if="item.change === 2" class="iconfont icon-xiajiang colorDR fz-md"></i>
                    <span class="colorWhite ml-10">{{ item.changeValue }}%</span>
                </div> -->
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.table-roll-box {
    position: relative;
    margin-top: 20px;
}

.table-roll {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    margin-left: 20px;
    overflow: hidden;
}

.table-roll li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
    left: 0;
    transition: all 2s;
    font-size: 16px;
}

.table-roll li.roll_0 {
    // opacity: 0.5;
    top: 0;
    /* font-size:10px; */
}

.table-roll li.roll_1 {
    // opacity: 0.8;
    top: 36px;
    /* font-size:14px; */
}

.table-roll li.roll_2 {
    top: 72px;
}

.table-roll li.roll_3 {
    top: 108px;
}

.table-roll li.roll_4 {
    opacity: 0;
    top: 144px;
}

.table-roll .roll_hide {
    display: none;
}

.border-roll {
    li {
        position: relative;
        height: 36px;
        width: 100%;
    }
}
</style>